<template>
    <div class="vx-row w-full ml-1 justify-center">
        <div id="productImageUpload" class="w-full sm:w-full md:w-8/12 lg:w-8/12 xl:w-8/12"> 
        <div class="border  d-theme-border-grey-light rounded overflow-hidden shadow-drop" style="background-color: white">
            <div class="vx-row items-no-padding">
            <img 
                :src="!tempImage && !productImage ? 
                    require('@/assets/images/no-photo2.png') : 
                    productImage && !tempImage ? productImage : tempImage" 
                style="width: 100%; height: 100%">
            </div>
            
        </div>
        <div class="w-full">
            <VueImageUploadCroppie class="mt-2" :defaultImage.sync="tempImageLocal" :height="317" :width="303" :circle="false" :trans="imgCompTranslate"></VueImageUploadCroppie>
        </div>
        </div>
    </div>
</template>

<script>
    import VueImageUploadCroppie from 'vue-image-upload-croppie'
    import * as imageConversion from 'image-conversion'
    import { mapState, mapMutations } from 'vuex'

    export default {
        components : {
            VueImageUploadCroppie
        },
        
        data () {
          return {
            tempImageLocal : '',
            imgCompTranslate: { 
                'cropImage': 'Alterar', 
                'chooseImage':'Escolher imagem', 
                'confirmCutting': 'Confirmar'
            },
          }
        },

        computed : {
          tempImage () {
            return this.tempImage
          },

          productImage () {
              return this.productInfo.image
          },

          ...mapState('product', ['productInfo', 'tempImageBase64', 'tempImage'])
        },

        watch : {
          'tempImageLocal': async function(base64image) {        
            if (base64image) {
              this.setTempImage(base64image)
              this.setTempImageBase64(base64image)
            }
          }
        },

        mounted() {
          this.setTempImage('')
        },

        methods : {
          convertToJPG (base64image) {
            return new Promise(async (resolve, reject) => {
              try {            
                var imgBlob = await imageConversion.dataURLtoFile(base64image)
                const convertedImg =  await imageConversion.compress(imgBlob, {
                  quality: 0.7,
                  type: 'image/jpeg'
                })
                resolve(convertedImg)
              } catch (err) {
                reject(err.message)
              }
            })
          },

          changeProduct() {
              this.product.description = "Teste ;)"
          },

          ...mapMutations('product', ['setImage', 'setTempImageBase64', 'setTempImage'])
        }
    }
</script>